"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = generateAnimationName;
function generateAnimationName(id) {
  return "k" + id;
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ../~/fela/lib/utils/generateAnimationName.js
// module id = 432
// module chunks = 0